import React, { Component, createRef } from "react";
import Banner from "../components/Banner";
import ClpTeacherBio from "../components/ClpTeacherBio";
import Footer from "../components/Footer";
import Header from "../components/Header";
import LatestBio from "../components/LatestBio";
import ShareDetails from "../components/ShareDetails";
import StoryCount from "../components/StoryCount";
import UpcommingBio from "../components/UpcommingBio";
import VideoModal from "../components/VideoModal";
import services from "../services";

import {Helmet} from 'react-helmet'

class TeacherDetails extends Component {
  constructor() {
    super();
    this.state = { isVideoModal: false, url: "", TeacherPageDetails:{}, isLoader:true, };
    this.myRef = createRef();
  }

  componentDidMount() {
    this.getTeacherBiographyDetails();

    console.log(this.props)
  }

  componentDidUpdate(prevProps){
    // const { match: { params } } = this.props;
    let currentBioId = this.props && this.props.match && this.props.match.params && this.props.match.params.id
    let previouBioId = prevProps && prevProps.match && prevProps.match.params && prevProps.match.params.id

    if(currentBioId !== previouBioId){
      
    this.getTeacherBiographyDetails();
    }
  }

  executeScroll = () => this.myRef.current.scrollIntoView();

  watchVideoNow = (url) => {
    this.setState({ url: url, isVideoModal: !this.state.isVideoModal });
  };

  getTeacherBiographyDetails = async () => {
    const { match: { params } } = this.props;

    let bioId = params.id

    const homeDetails = await services.getApiCall(`v2/course/tutorBio/${bioId}`);
    
    this.setState({TeacherPageDetails:homeDetails.data.data, isLoader:false});
  }

  render() {
    const { isVideoModal, url, TeacherPageDetails } = this.state;
    console.log(TeacherPageDetails);
    return (
      <div className="Home">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{`${TeacherPageDetails && TeacherPageDetails.banner && TeacherPageDetails.banner.title}`} | Teachers' Biographies</title>
          <meta name="description" content={`${TeacherPageDetails && TeacherPageDetails.banner && TeacherPageDetails.banner.description}`} />         
          
        </Helmet>
        <Header executeScroll={this.executeScroll} />
        <Banner
          isVideoModal={isVideoModal}
          watchVideoNow={this.watchVideoNow}
          bannerData={TeacherPageDetails && TeacherPageDetails.banner}
        />
        <div className="Home__Container">
          <LatestBio latestBioData={TeacherPageDetails && TeacherPageDetails.latest}/>
          <UpcommingBio upcomingBioData={TeacherPageDetails && TeacherPageDetails.upcoming} />
          <ClpTeacherBio title={TeacherPageDetails && TeacherPageDetails.mediaCoverage && TeacherPageDetails.mediaCoverage.title} mediaCoverage={TeacherPageDetails && TeacherPageDetails.mediaCoverage} />
          {/* <StoryCount /> */}
          <div ref={this.myRef}></div>
          <ShareDetails />
        </div>
        <Footer />
        {isVideoModal ? (
          <VideoModal closeModal={this.watchVideoNow} url={url} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default TeacherDetails;
